export default (value) => (state = value, action = {}) => {
    return state;
};